import { useEffect, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { theme } from "../theme.js";
import Hero from "../components/hero";
import EventCard from "../components/eventcard";
import LoadingOverlay from "../components/LoadingOverlay.jsx";

export default function HomePage({ events, loading, error }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Vérifier si on revient d'un callback Google OAuth avec succès
    const success = searchParams.get("success");
    const email = searchParams.get("email");
    const firstname = searchParams.get("firstname");
    const lastname = searchParams.get("lastname");

    if (success === "true" && email) {
      // Créer l'objet utilisateur et le sauvegarder dans localStorage
      const userData = {
        email,
        name: `${firstname} ${lastname}`,
        firstname,
        lastname,
        user_id: email
      };
      
      localStorage.setItem("user", JSON.stringify(userData));
      console.log("User saved to localStorage:", userData);
      
      // Nettoyer l'URL des paramètres
      navigate("/user" , { replace: true }); 
    }
  }, [searchParams, navigate]);

  // Memoize sorted and limited events to avoid recalculation on every render
  const limitedEvents = useMemo(() => {
    return events
      .sort((a, b) => new Date(a.start_date) - new Date(b.start_date))
      .slice(0, 12);
  }, [events]);

  return (
    <>
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
      <Hero />

      <main style={styles.page}>
        <h2 style={styles.title}>Prochains Événements</h2>

        {error && <p style={{ color: theme.colors.error, textAlign: "center" }}>{error}</p>}

        {!error && (
          <div style={styles.grid}>
            {loading ? (
              // Show loading skeleton instead of full-screen overlay
              Array.from({ length: 6 }).map((_, i) => (
                <div key={i} style={{
                  backgroundColor: '#f0f0f0',
                  borderRadius: '8px',
                  height: '200px',
                  animation: 'pulse 2s infinite'
                }} />
              ))
            ) : (
              <>
                {limitedEvents.length === 0 && <p style={{ gridColumn: "1 / -1", textAlign: "center" }}>Aucun événement trouvé.</p>}
                {limitedEvents.map((ev) => (
                  <EventCard event={ev} key={ev.id_bdd || ev.id || JSON.stringify(ev)} />
                ))}
              </>
            )}
          </div>
        )}
        
        <div style={styles.buttonContainer}>
          <a 
            href="/events"
            style={styles.viewAllLink}
          >
            Voir tous les événements
          </a>
        </div>
      </main>
    </>
  );
}

const styles = {
  page: { 
    width: "100%", 
    margin: "0 auto", 
    padding: `${theme.spacing.huge} ${theme.spacing.xxl}`,
    backgroundColor: theme.colors.bgLight
  },
  title : {
    fontSize: theme.fonts.size.massive,
    fontWeight: theme.fonts.weight.bold,
    color: theme.colors.textInverted,
    marginBottom: theme.spacing.xxl,
  },  
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    justifyContent: "start",
    gap: theme.spacing.xxl,
    marginBottom: theme.spacing.xxl,
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing.xxl,
  },
  viewAllLink: {
    fontSize: theme.fonts.size.lg,
    fontWeight: theme.fonts.weight.medium,
    color: theme.colors.textInverted,
    textDecoration: "underline",
    cursor: "pointer",
    transition: `color ${theme.transitions.base}`,
  },
};  
